/**
 * Created by Evžen Rejfíř on 22.07.2025.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const TARIFF_TYPE_ZAKLAD = "zaklad";
export const TARIFF_TYPE_STANDARD = "standard";
export const TARIFF_TYPE_PROFI = "profi";
export const TARIFF_TYPE_PROFI_PLUS = "profi-plus";

export const TariffTypes = {
    [TARIFF_TYPE_ZAKLAD]: {
        name: "Základ",
        priority: 10,
        hours: 0,
        priceCZK: 0,
    },
    [TARIFF_TYPE_STANDARD]: {
        name: "Standard",
        priority: 20,
        hours: 4,
        priceCZK: 7700,
    },
    [TARIFF_TYPE_PROFI]: {
        name: "Profi",
        priority: 30,
        hours: 8,
        priceCZK: 14000,
    },
    [TARIFF_TYPE_PROFI_PLUS]: {
        name: "Profi+",
        priority: 40,
        hours: 16,
        priceCZK: 28800,
    },
};

export default declareEntity({
    entity: "tariffs",
    graphQL: "Tariff",
    name: "Tariffs",
    dynamoPrefix: 'org',
    storageType: 'central',
    writePermission: [
        Permission.PERM_DEVELOPER
    ],
    createPermission: [
        Permission.PERM_DEVELOPER
    ],
    defaultTitle: (data) => {
        return data['tariffNumber'];
    },
    defaultOrder: [['createdAt', 'DESC']],
    fields: (types) => { return {
        id: {
            name: "Tariff ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation",
            to: () => types['organisations'],
            type: "relation",
            required: true,
            userEditable: false,
            hiddenCreate: true,
        },
        instance: {
            name: "Instance",
            to: () => types['instances'],
            type: "relation",
            required: true,
            userEditable: false,
            hiddenCreate: true,
        },
        tariffType: {
            name: "Tariff Type",
            type: "enum",
            defaultValue: TARIFF_TYPE_ZAKLAD,
            values: TariffTypes,
            required: true,
            filterable: true,
        },
        startDate: {
            name: "Start Date",
            type: "date",
            required: true,
            defaultValue: () => {
                return new Date().toISOString().split('T')[0];
            },
        },
        endDate: {
            name: "End Date",
            type: "date",
            required: false,
            description: "If not filled, the tariff is valid indefinitely",
        },
        active: {
            name: "Active",
            type: "boolean",
            userEditable: false,
            computed: true,
            description: "Computed based on current date vs start/end dates",
        },
        customerNumber: {
            name: "Customer Number",
            type: "string",
            userEditable: false,
            length: 6,
            description: "6-digit number generated from organisation name",
        },
        tariffNumber: {
            name: "Tariff Number",
            type: "string",
            userEditable: false,
            description: "Composed of customer number and tariff sequence (e.g. 123456-1)",
        },
        orderNumber: {
            name: "Order Number",
            type: "integer",
            userEditable: false,
            description: "Sequential number for this organisation's tariffs",
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            userEditable: false,
            defaultValue: () => {
                return new Date().toISOString();
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            userEditable: false,
            defaultValue: () => {
                return new Date().toISOString();
            },
        },
    }; },

    getBL: function() {
        return {
            canCreate: function(permissionObject, data) {
                return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
            },
            canUpdate: function(permissionObject, data) {
                return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
            },
            canDelete: function(permissionObject, data) {
                return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
            },
            canRead: function(permissionObject, data) {
                return Permission.hasPermissionInternal(Permission.PERM_DEVELOPER, permissionObject);
            },
        };
    },
});
